import { ajaxForm } from "../../../../src/module/form";
import { appConfig } from '../../../../src/appConfig';

declare let fbq: (...args: any[]) => void

export enum EnquiryFormType {
    General = 'General',
    Course = 'Course',
    Franchise = 'Franchise',
    Camp = 'Camp'
}

export function setupEnquiryForm(type: EnquiryFormType) {
    const elementId = 'enquiryForm';

    ajaxForm({
        elementId: elementId,
        beforeSend: () => {
            document.querySelector<HTMLElement>(`#${elementId} .buttonSubmit`).style.display = 'none';
            document.querySelector<HTMLElement>(`#${elementId} .buttonLoading`).style.display = 'block';
            document.querySelector<HTMLElement>(`#${elementId} .buttonError`).style.display = 'none';
        },
        error: (errorText) => {
            document.querySelector<HTMLElement>(`#${elementId} .buttonSubmit`).style.display = 'none';
            document.querySelector<HTMLElement>(`#${elementId} .buttonLoading`).style.display = 'none';
            document.querySelector<HTMLElement>(`#${elementId} .buttonError`).style.display = 'block';
            console.log(errorText);
        },
        processing: () => {
            //upload percentage
        },
        success: () => {
            document.querySelector<HTMLElement>(`#${elementId} .buttonSubmit`).style.display = 'none';
            document.querySelector<HTMLElement>(`#${elementId} .buttonLoading`).style.display = 'none';
            document.querySelector<HTMLElement>(`#${elementId} .buttonError`).style.display = 'none';
            document.querySelector<HTMLElement>(`#${elementId} .buttonSuccess`).style.display = 'block';
            (document.getElementById(elementId) as HTMLFormElement).reset();
            gtag('event', 'enquiry', {
                send_to: appConfig.googleAnalyticsId,
                event_category: 'engagement',
                event_label: type
            });
            gtag('event', 'generate_lead', {
                send_to: appConfig.googleAnalytics4Id
            });
            gtag('event', 'enquiry', {
                send_to: appConfig.googleAnalytics4Id,
                type
            });
            fbq('trackCustom', `${type}Enquiry`);
        },
        finally: () => {
            //finish all job
        }
    });
}

